import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import {brandDetector} from '@/brands';

let brandStyles = brandDetector();


const info = {
	state: {
		textosInfoPopup : {
			cv_documentacion : {
				titulo : 'Autorizo el uso de mi CV',
				texto : 'Si autorizas, tenemos tu permiso para presentar tu CV a ofertas y empresas que consideremos que sean de tu interés, se publiquen o no en el portal. Te avisaremos cada vez que te presentemos a una oferta.'
			},
			uso_logo : {
				titulo : 'Autorizo el uso de la imagen de la empresa',
				texto : 'Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en los portales de estudiantes y antiguos alumnos/as. Aunque autorices, cuando crees ofertas podrás configurar si quieres que se muestren los datos de tu empresa o no.'
			},
			mostrar_empresa : {
				titulo : 'Quiero ocultar los datos de mi empresa para esta oferta',
				texto : 'Por defecto, mostraremos los datos básicos de tu empresa en cada oferta que publiques. Si quieres publicar anónimamente, marca esta opción, no se mostrarán ni logo ni el nombre de tu empresa.'
			},
			url_portfolio : {
				titulo : 'URL del documento',
				texto : 'Si no puedes añadir tu documento porque supera 2Mb, añade aquí la url donde está alojado.'
			},
			info_oferta_pendiente : {
				titulo : '¡Atención!',
				texto : 'Solamente puedes modificar los detalles de tus ofertas mientras estén “pendiente” de validar y no caducadas. Si quieres modificar cualquier detalle una oferta que no está pendiente, por favor contacta con nosotros.'
			},
			comunicaciones_email_personal : {
				titulo : 'Avisos en el email personal',
				texto : 'Marca esta casilla si quieres recibir las comunicaciones relacionadas con prácticas o empleo en tu email personal, en vez de en tu email de estudiante.'
			},
			editar_personales : {
				titulo : 'Edición de datos personales',
				texto : 'Si alguno de los datos no editables no es correcto, por favor, contacta con nosotros para indicarte dónde acudir para modificarlo.'
			},
			busquedaactivapracticas : {
				titulo : 'Búsqueda activa',
				texto : 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de prácticas. Además, consientes en que se envíe tu candidatura desde los servicios de prácticas y empleo de la universidad, sin inscripción previa por tu parte.'
			},
			busquedaactivaempleo : {
				titulo : 'Búsqueda activa',
				texto : 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de empleo. Además, consientes en que se envíe tu candidatura desde los servicios de prácticas y empleo de la universidad, sin inscripción previa por tu parte.'
			},
			busquedaactivaempleo_uib : {
				titulo : 'Búsqueda activa',
				texto : 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de empleo.'
			},
			documentacion : {
				titulo : 'Documentación',
				texto : '¡Atención! Asegúrate de tener la información actualizada, las empresas a las que se mande tu currículum podrán acceder a esta documentación. Al subir cualquier archivo, consientes a que todas las empresas que tienen tu currículum accedan a esta información.'
			},
			limitaciones_fichero : {
				titulo : 'Ficheros permitidos',
				texto : '¡Atención! Los ficheros no pueden superar los 5Mb. Las extensiones permitidas son las siguientes: docx, doc, pdf, odt, odp, txt, pptx, pps, ppsx, ppt, csv, xlsx, png, jpg, jpeg, bmp, gif, tiff y tif.'
			},
			documentos_empresa : {
				titulo : 'Documentación de tu empresa',
				texto : 'Si se te ha requerido o deseas aportar documentación adicional podrás adjuntarla aquí. ¡Atención! Asegúrate de tener la información actualizada, si alguno de los documentos ya subidos no está actualizado, elimínalo y dalo de alta de nuevo.'
			},
			documentos_privados : {
				titulo : "Documentación privada",
				texto : "Si lo deseas, o se te ha requerido aportar documentación podrás adjuntarla aquí. Las empresas no tendrán acceso a esta información. ¡Atención! Asegúrate de tener la información actualizada, si alguno de los documentos ya subidos no está actualizado, tendrás que darlo de alta de nuevo."
			},
			documentacion_ligada_procesos : {
				titulo : "Documentación ligada a procesos",
				texto : "Si en algún proceso del que formas parte, la empresa ha solicitado documentación específica, podrás darla de alta aquí."
			},
			registro_alumnos : {
				titulo : "",
				texto : "Indica la titulación que consideres más relevante, podrás completar tu perfil con otras titulaciones una vez registrado/a."
			},
			adherido_universidad : {
				titulo : "",
				texto : "Estudios realizados en alguno de estos centros: Universidad de Salamanca, Colegio Santísima Trinidad, Colegio Salesiano San José o IES Venancio Blanco"
			},
			ocultar_empresa : {
				titulo : "Me gustaría que el nombre de mi empresa fuera visible.",
				texto : "Por defecto, no mostraremos los datos básicos de tu empresa en cada oferta que publiques. Si quieres publicarlo, marca esta opción y se mostrarán logo, nombre, contacto... de tu empresa."
			},
			envio_postal : {
				titulo : "Domicilio para el envio postal de facturas",
				texto : "Por favor indique la dirección completa con código postal y localidad a la que podemos enviar las facturas en formato papel (no digital) que, en su caso, sean necesarias."
			},
			descargarcv : {
				titulo : "Ver CV",
				texto : "Pinchando en este botón te descargas un PDF con tu currículum autogenerado con los datos de tu perfil.<br><br>Este PDF es el que recibe la empresa cuando se envía tu candidatura a cualquier oferta, así que te recomendamos tenerlo lo más actualizado y completo posible.<br><br>Si lo deseas también puedes adjuntar tu propia versión de CV desde el epígrafe “Mis documentos”, aunque la empresa siempre recibirá también el autogenerado."
			},
			discapacidad_uc3m : {
				titulo : "",
				texto : "El dato de discapacidad no será visible ni en tu CV ni en el perfil que consulten las empresas de tus futuras candidaturas. Será únicamente tratado desde la Oficina de Prácticas y Empleo de UC3M.<br>Recuerda que existen programas específicos de prácticas y empleo para usuarios con discapacidad certificada."
			},
			candidato_preferido : {
				titulo : "",
				texto : "Por favor indica nombre, apellidos y DNI del candidato/a preferido/a."
			},
			datos_realizacion : {
				titulo : "",
				texto : "Completa este campo en función de los conocimientos específicos que pondrá en práctica el estudiante seleccionado, la formación que adquirirá, así como el seguimiento que vaya a realizarse de la realización de las prácticas, por ejemplo: reunión presencial semanalmente."
			},
			"convenio Generado" : {
				titulo : "Convenio generado",
				texto : "El convenio ha sido generado y está pendiente de firmar por parte de tu empresa."
			},
			"convenio Formalizado" : {
				titulo : "Convenio formalizado",
				texto : "El convenio ya está formalizado."
			},
			"convenio Firmado empresa" : {
				titulo : "Convenio Firmado empresa",
				texto : "El convenio ya ha sido firmado tu empresa y está pendiente de revisión y firma por parte de la FUNDACIÓN UNIVERSIDAD CARLOS III"
			},
			"convenio Erróneo empresa" : {
				titulo : "Convenio Erróneo empresa",
				texto : "El convenio contiene algún error y debe ser revisado."
			},
			"convenio Caducado" : {
				titulo : "Convenio Caducado",
				texto : "El convenio ha caducado"
			},
			"convenio Enviado Secretaría" : {
				titulo : "Convenio Enviado secretaría",
				texto : "El convenio esta enviado y pendiente de revisión por secretaría"
			},
			"notamedia" : {
				titulo : "Nota media",
				texto : 'Nota media de 1 a 4. Consulta las <a target="_blank" href="https://sede.csic.gob.es/tabla_conversion">equivalencias</a>.'
			},
			"ayudaestudio" : {
				titulo : "Beca mensual",
				texto : 'En el caso de programas subvencionados este importe se sumará a la subvención como bolsa complementaria.'
			},
			"numero_seguridad_social": {
				titulo: "",
				texto: "<p> <strong>¿Cómo obtener mi número de la SS?</strong> <p>En la Administración de la Tesorería General de la Seguridad Social en la que radique el domicilio del ciudadano o donde esté domiciliada la empresa en que presta servicios el trabajador. Si dispone de un certificado digital puede acceder al <u><a href='https://sede.seg-social.gob.es/wps/portal/sede/sede/Ciudadanos/afiliacion+e+inscripcion/202088?changeLanguage=es' target='_blank'>servicio Asignación de número de la Seguridad Social en la Sede Electrónica</a></u>.</p>"
				
			},
			"ofertaParaIntermediacion": {
				titulo: "",
				texto: "<p>Esta oferta se enmarca dentro del Programa de Intermediación Laboral subvencionado por la Junta de Castilla y León (Servicio Público de Empleo de Castilla y León).</p>"
				
			}
		},
		owntexts : brandStyles.ownpopup_info
	},
	getters: {
		getInfoPopup : state => {
			return (value) => {
				let textos;

				if(state.owntexts){
					textos = (!!state.owntexts[value]) ? state.owntexts[value] : state.textosInfoPopup[value];
				}else{
					textos = state.textosInfoPopup[value];
				}

				return textos;
			}
		},
	},
	actions: {
		
	},
	mutations: {
		
	}
}

export default info;



// WEBPACK FOOTER //
// ./src/store/popup-info.js